const FontList = [
  'Arial',
  'Bahnschrift',
  'Calibri',
  'Cambria',
  'Cambria Math',
  'Candara',
  '"Comic Sans MS',
  'Consolas',
  'Constantia',
  'Corbel',
  'Courier New',
  'Ebrima',
  'Franklin Gothic',
  'Gabriola',
  'Gadugi',
  'Georgia',
  'Global Monospace',
  'Global Sans Serif',
  'Global Serif',
  'Global User Interface',
  'HoloLens MDL2 Assets',
  'Impact',
  'Ink Free',
  'Javanese Text',
  'Leelawadee UI',
  'Lucida Console',
  'Lucida Sans Unicode',
  'Malgun Gothic',
  'Marlett',
  'Microsoft Himalaya',
  'Microsoft JhengHei UI',
  'Microsoft JhengHei',
  'Microsoft New Tai Lue',
  'Microsoft PhagsPa',
  'Microsoft Sans Serif',
  'Microsoft Tai Le',
  'Microsoft YaHei UI',
  'Microsoft Yi Baiti',
  'MingLiU-ExtB',
  'MingLiU_HKSCS-ExtB',
  'Mongolian Baiti',
  'MS Gothic',
  'MS PGothic',
  'MS UI Gothic',
  'MV Boli',
  'Myanmar Text',
  'Nirmala UI',
  'Palatino Linotype',
  'PMingLiU-ExtB',
  'Segoe MDL2 Assets',
  'Segoe Print',
  'Segoe Script',
  'Segoe UI Emoji',
  'Segoe UI Historic',
  'Segoe UI Symbol',
  'Segoe UI',
  'SimSun-ExtB',
  'Sitka Banner',
  'Sitka Display',
  'Sitka Heading',
  'Sitka Small',
  'Sitka Subheading',
  'Sitka Text',
  'Sylfaen',
  'Symbol',
  'Tahoma',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
  'Webdings',
  'Wingdings',
  'Yu Gothic UI',
  'Yu Gothic',
];

const FontNumber = [
  '8',
  '9',
  '10',
  '11',
  '12',
  '14',
  '16',
  '18',
  '20',
  '22',
  '24',
  '26',
  '28',
  '36',
  '48',
  '72',
];
const HeaderStyle = ['User image', 'Default'];
const FooterStyle = ['User image', 'email,phone,address,web', 'Company Name'];
const ABNLocation = ['Footer', 'Under Tax Invoice', 'None'];
const RELINEJustification = ['Left', 'Centre', 'Right'];
const PERSONResposible = ['Owner', 'Primary Fee Earner', 'None'];
const SHOWSolicitorSummary = ['On First Page', 'At End', 'None'];
const SHOWRemittance = ['On First Page', 'At End', 'At end at bottom', 'None'];
const DIRECTDEBITACCOUNTRemittance = [
  'Practice Account',
  'Trust Account',
  'Owner Account',
  'Primary Fee Earner Account',
  'Manual Entry',
];
const SHOWDelivarableSummary = ['On First Page', 'At End', 'None'];
const ShowWithCompliments = ['On First Page', 'At End', 'None'];
const SOLSUMMARYSTYLE = ['Condensed', 'Expanded'];
const SHOWStatement = ['On First Page', 'At End', 'None', 'At End With New Page'];
const SHOWRemittances = ['Matter Setting', 'Inclusive', 'Exclusive'];
const SHOWTaxes = ['Inclusive', 'Exclusive', 'Matter Setting'];
const DISPLAYQuantitiyType = ['hours', 'units', 'hh:mm', 'minutes', 'As Entered'];
const SHOWWorkItemQuantity = ['Hide', 'Append To End Of Text', 'Own Column'];
const SHOWDistrubmentPayee = ['Hide', 'Append To End Of Text', 'Own Column'];
const OUTStandingTable = ['Matter', 'Client', 'None'];

export const GSUITE_CONST = {
  FontNumber,
  FontList,
  HeaderStyle,
  FooterStyle,
  ABNLocation,
  RELINEJustification,
  PERSONResposible,
  SHOWSolicitorSummary,
  SHOWDelivarableSummary,
  SHOWRemittance,
  SOLSUMMARYSTYLE,
  SHOWStatement,
  SHOWTaxes,
  DISPLAYQuantitiyType,
  SHOWDistrubmentPayee,
  SHOWWorkItemQuantity,
  OUTStandingTable,
  ShowWithCompliments,
  SHOWRemittances,
  DIRECTDEBITACCOUNTRemittance,
};
